import { toast } from "react-toastify";

const handleError = (err: any, alternateErrorMessage: string, cb?: any,networkErrorMessage?:string) => {
    if (window.navigator.onLine && err) {
        let error: Array<string> | string = err?.response?.data?.msg;
        let errorMessage = error?.length > 0 ? Array.isArray(error) ? error.join() : error : alternateErrorMessage;
        if (cb) {
            cb(errorMessage)
        }
        toast.error(errorMessage);
    } else {
        toast.error(networkErrorMessage??'Network Error');
    }
}

export default handleError